import React, { useEffect, useState } from 'react';
import { convertHeightInScale } from '../../utils/CommonUtils';

const profileData = [
  // {
  //   icon: '/assets/images/user/user-profile/ethnicity.svg',
  //   label: 'Ethnicity',
  //   value: '',
  //   type: 'Ethnicity',
  // },
  // {
  //   icon: '/assets/images/user/user-profile/children.svg',
  //   label: 'Children',
  //   value: '',
  //   type: 'Children',
  // },
  // {
  //   icon: '/assets/images/user/user-profile/do-you-smoke.svg',
  //   label: 'Do you smoke?',
  //   value: '',
  //   type: 'Smoke',
  // },
  // {
  //   icon: '/assets/images/user/user-profile/do-you-drink.svg',
  //   label: 'Do you drink?',
  //   value: '',
  //   type: 'Drink',
  // },
  // {
  //   icon: '/assets/images/user/user-profile/education.svg',
  //   label: 'Education',
  //   value: '',
  //   type: 'highestEducation',
  // },
  // {
  //   icon: '/assets/images/user/user-profile/annual-income.svg',
  //   label: 'Annual income',
  //   value: '',
  //   type: 'incomeRange',
  // },
    {
    icon: '/assets/images/user-profile/height.svg',
    label: 'Height',
    value: '',
    type: 'height',
  },
      {
    icon: '/assets/images/user-profile/relationship.svg',
    label: 'Relationship',
    value: '',
    type: 'currentRelationshipStatus',
  },
  {
    icon: '/assets/images/user/user-profile/occupation.svg',
    label: 'Occupation',
    value: '',
    type: 'workField',
  },
    {
    icon: '/assets/images/user-profile/body-type.svg',
    label: 'Body Type',
    value: '',
    type: 'bodyType',
  },
      {
    icon: '/assets/images/user-profile/intent-icon.svg',
    label: 'Intent',
    value: '',
    type: 'relationshipGoal',
  },
  {
    icon: '/assets/images/user-profile/who-are-you.svg',
    label: 'Who are you interested in',
    value: '',
    type: 'interested',
  },
  {
    icon: '/assets/images/user-profile/gender.svg',
    label: 'Gender',
    value: '',
    type: "gender"
  },
  {
    icon: '/assets/images/user/user-profile/verification.svg',
    label: 'Verification',
    value: '',
    type: 'isProfileVerified',
  },
];

const UserProfileDetails = ({ userData }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!userData) return;
    const memeberData = {...userData,interested:userData?.preferences?.gender?.[0] || ""}

    const updatedProfileData = profileData.map((item) => {
      // const userDataKey = item.type;
      const userDataKey =
        item.type.charAt(0).toLowerCase() + item.type.slice(1);
      const value = item.type==="height" ? (convertHeightInScale(memeberData.tall) ?? "") :  memeberData[userDataKey]
      return {
        ...item,
        value: value===true ? "Approved" : (value===false ? "Pending" : (value || "")) 
      };
    });

    setData(updatedProfileData);
  }, [userData]);

  console.log("userData",userData)

  return (
    <div className="w-100 d-flex flex-column align-content-center gap-12">
      {/* Profile Details */}
      {data.map((item, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '8px 10px',
            gap: '12px',
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={item.icon}
              alt={item.label}
              style={{ width: '24px', height: '24px', marginRight: '10px' }}
            />
            <span
              className="font-14 fw-medium font-m"
              style={{ color: '#3C4043' }}
            >
              {item.label}
            </span>
          </span>
          <span
            className="text-end"
            style={{ color: '#5F6368', fontSize: '14px', fontWeight: 'normal' }}
          >
            {item.value}
          </span>
        </div>
      ))}

      {/* Verifications Section */}
      {/* <h3 className="pt-24 d-flex justify-content-between align-items-center" style={{ fontSize: '16px', fontWeight: "bold", color: '#3C4043' }}>
                Verifications <VerifiedOutlinedIcon style={{ color: '#BF8500' }} />
            </h3>
            <div style={{ marginBottom: "10px" }}>
                {verifications.map((text, index) => (
                    <p key={index} style={{ marginBottom: "5px", fontSize: '14px', color: '#3C4043' }}>
                        {text}
                    </p>
                ))}
            </div> */}

      {/* Tags Section */}
      {/* <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                {tags.map((tag, index) => (
                    <span
                        key={index}
                        style={{
                            border: "1px solid #ddd",
                            borderRadius: "20px",
                            padding: "5px 10px",
                            backgroundColor: "#f9f9f9",
                            fontSize: "0.9rem",
                        }}
                    >
                        {tag}
                    </span>
                ))}
            </div> */}
    </div>
  );
};

export default UserProfileDetails;
